import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82cea7d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "label required-container"
}
const _hoisted_2 = {
  key: 0,
  class: "required-label"
}
const _hoisted_3 = {
  class: "textbox-container",
  "data-bind": "dxTextBox: {}"
}

import { PropType, computed, ref, watch, onMounted } from "vue";
import { DxValidator } from "devextreme-vue";
import { DxTextBox } from "devextreme-vue/text-box";
import {
  DxRequiredRule,
  DxCustomRule,
  DxPatternRule,
} from "devextreme-vue/validator";
import { FieldSize } from "@/enums/system/FieldSize";
import { ValidatedEvent } from "devextreme/ui/validator";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";


export default /*#__PURE__*/_defineComponent({
  __name: 'field-validation-free-textbox',
  props: {
  /**
   * The maximum width of the input field (for CSS styling).
   * @type {string}
   * @default '50'
   */
  maxLength: {
    type: String,
    default: "50",
  },
  /**
   * The minimum width of the input field (for CSS styling).
   * @type {string}
   * @default '0'
   */
  minLength: {
    type: String,
    default: "0",
  },
  /**
   * The string value used with `v-model` to control the visibility or state of a modal or component.
   * @type {string}
   * @required
   */
  modelValue: {
    type: String,
    required: true,
  },
  /**
   * The width of the input field, defined by `FieldSize`.
   * @type {FieldSize}
   * @default FieldSize.Full
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
  /**
   * Determines whether the specific control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * A custom validation function for validating the input field.
   * @type {Function}
   * @optional
   */
  customValidation: {
    type: Function,
    required: false,
  },
  /**
   * The message to display when validation fails.
   * @type {string | undefined}
   */
  invalidMessage: {
    type: String,
    required: false,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * Determines whether the input control is required.
   * @type {boolean}
   * @default false
   */
  requiredInput: {
    type: Boolean,
    default: false,
  },
  /**
   * The validation group name used for form validation.
   * @type {string}
   * @default ''
   */
  validationGroup: {
    type: String,
    required: false,
    default: "",
  },
  /**
   * Determines whether the control is numeric field.
   * @type {boolean}
   * @default false
   */
  numericalField: {
    type: Boolean,
    required: false,
  },
  /**
   * The message to display when the numerical input is invalid.
   * @type {string | undefined}
   */
  invalidNumericalMessage: {
    type: String,
    required: false,
  },
  /**
   * Placeholder text for the input field.
   * @type {string}
   * @default ''
   */
  placeholder: {
    type: String,
    default: "",
  },
  /**
   * Determines whether leading zeros should be displayed.
   * @type {boolean}
   * @default false
   */
  displayLeadingZeros: {
    typre: Boolean,
    default: false,
  },
  /**
   * The event type that triggers a value change.
   * @type {TextboxValueChangeEvent}
   * @default TextboxValueChangeEvent.Change
   */
  valueChangeEvent: {
    type: String as PropType<TextboxValueChangeEvent>,
    default: TextboxValueChangeEvent.Change,
  },
  /**
   * Determines whether to show Clear button.
   * @type {boolean}
   * @default false
   */
  showClearButton: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether the input field is for passwords.
   * @type {boolean}
   * @default false
   */
  isPassword: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "focusOut"],
  setup(__props, { emit }) {

const props = __props;



const value = computed({
  get: () => props.modelValue,
  set: (val: string) => emit("update:modelValue", val),
});



/** Custom validation configuration to override DevExpress default validation method */
const adapterConfig = {
  getValue: () => {
    return value.value;
  },
  applyValidationResults: (e: ValidatedEvent) => {
    isValid.value = !!e.isValid;

    // Construct list of validation errors to be displayed to the user when they hover over the field
    validationErrors.value =
      !e.isValid && e.brokenRule?.message ? e.brokenRule.message : "";
  },
  validationRequestsCallbacks: [],
};

const validationErrors = ref("");
const isValid = ref(true);
const textboxMode = ref("text");

onMounted(() => {
  textboxMode.value = props.isPassword ? "password" : "text";
});

watch(
  () => props.isPassword,
  () => {
    textboxMode.value = props.isPassword ? "password" : "text";
  },
);

const requiredMessage = computed(() =>
  props.label ? `${props.label} is required` : "This field is required",
);

const minLengthValidation = (e: any) => {
  if (!e.value || props.minLength === "0") {
    return true;
  }

  return e.value.length >= props.minLength;
};

const focusOut = () => {
  let formattedValue = value.value.trim();

  if (props.displayLeadingZeros && value.value.length > 0) {
    formattedValue = formattedValue.padStart(Number(props.maxLength), "0");
  }

  value.value = formattedValue;

  emit("focusOut");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(__props.label), 1),
          (props.requiredInput)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Required"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DxTextBox), {
        value: value.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        "max-length": props.maxLength,
        width: __props.width,
        "read-only": props.readOnly,
        isValid: isValid.value,
        hint: validationErrors.value,
        mode: textboxMode.value,
        placeholder: props.placeholder,
        valueChangeEvent: __props.valueChangeEvent,
        onFocusOut: focusOut,
        "show-clear-button": __props.showClearButton
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxValidator), {
            adapter: adapterConfig,
            "validation-group": props.validationGroup
          }, {
            default: _withCtx(() => [
              (props.requiredInput)
                ? (_openBlock(), _createBlock(_unref(DxRequiredRule), {
                    key: 0,
                    message: requiredMessage.value
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              (props.customValidation)
                ? (_openBlock(), _createBlock(_unref(DxCustomRule), {
                    key: 1,
                    reevaluate: true,
                    "validation-callback": __props.customValidation,
                    message: props.invalidMessage
                  }, null, 8, ["validation-callback", "message"]))
                : _createCommentVNode("", true),
              (props.minLength)
                ? (_openBlock(), _createBlock(_unref(DxCustomRule), {
                    key: 2,
                    reevaluate: true,
                    "validation-callback": minLengthValidation,
                    message: props.invalidMessage
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              (props.numericalField)
                ? (_openBlock(), _createBlock(_unref(DxPatternRule), {
                    key: 3,
                    pattern: "^[0-9]+$",
                    message: props.invalidNumericalMessage
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["validation-group"]),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["value", "max-length", "width", "read-only", "isValid", "hint", "mode", "placeholder", "valueChangeEvent", "show-clear-button"])
    ])
  ], 64))
}
}

})